import { AppTypeId } from '@ps/platform-message-framework/common/AppTypeId';
import { ProductId } from '@ps/platform-message-framework/common/ProductId';
import { LoginSource } from '@ps/web-core-store';
import { canUseDOM } from '@ps/web-core-utils';

import { Header } from '@swf/core/enums';
import type { LoginPayload } from '@swf/core/models/auth/login';
import type { EffectParams } from '@swf/core/store';
import { select } from '@swf/core/store';
import type { RequestOptions } from '@swf/core/types/Request';
import { fetchJson } from '@swf/core/utils/api';

const getIdpFrame = () => {
  const element = canUseDOM && document.getElementById('idp-client');
  return element instanceof HTMLIFrameElement ? element : undefined;
};

export const requestIdpToken = async (
  {
    headers,
    body,
    loginSource
  }: { headers: RequestOptions['headers']; body: URLSearchParams; loginSource: LoginSource },
  { dispatch, rootState }: Pick<EffectParams, 'dispatch' | 'rootState'>
) => {
  const { apiDomain = '' } = select.config.get(rootState);

  try {
    if (apiDomain) {
      if (loginSource === LoginSource.Login) {
        const { access_token: idpToken, refresh_token: idpRefreshToken } = await fetchJson(
          `${apiDomain}/oauth2/token`,
          {
            headers,
            body,
            method: 'POST'
          }
        );

        getIdpFrame()?.contentWindow?.postMessage(
          // eslint-disable-next-line @typescript-eslint/naming-convention
          { access_token: idpToken, refresh_token: idpRefreshToken },
          '*'
        );
        dispatch.session.update({ idpToken });
      }
    }
  } catch {
    // do nothing for now
  }
};

const idpLogin = async (
  payload: LoginPayload,
  { dispatch, rootState }: Pick<EffectParams, 'dispatch' | 'rootState'>
) => {
  const { installId = '' } = select.session.get(rootState);
  const site = String(select.cms.getSiteId(rootState));
  const deviceId = String(select.device.getId(rootState));
  const osId = String(select.device.getOS(rootState));
  const brandId = String(select.cms.getBrandId(rootState));
  const platformId = String(select.device.getPlatform(rootState));

  const idpLoginBody = new URLSearchParams({
    username: payload.userId,
    password: payload.password,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    grant_type: 'password'
  });

  await requestIdpToken(
    {
      headers: {
        [Header.FiSiteId]: site,
        [Header.FiDeviceId]: deviceId,
        [Header.FiOsId]: osId,
        [Header.FiBrandId]: brandId,
        [Header.FiInstallId]: installId,
        [Header.FiAppTypeId]: String(AppTypeId.RAM),
        [Header.FiProductId]: String(ProductId.UNKNOWN),
        [Header.FiPlatformId]: platformId
      },
      body: idpLoginBody,
      loginSource: LoginSource.Login
    },
    { dispatch, rootState }
  );
};

export const idpLogout = () => {
  getIdpFrame()?.contentWindow?.postMessage('IDP_LOGOUT', '*');
};
export default idpLogin;
